// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopCustomerAccountLinkControllerApproveManagedCardData } from './EshopCustomerAccountLinkControllerApproveManagedCardData.gen';
import type { EshopCustomerAccountLinkControllerApproveManagedCardErrors } from './EshopCustomerAccountLinkControllerApproveManagedCardErrors.gen';
import type { EshopCustomerAccountLinkControllerApproveManagedCardResponses } from './EshopCustomerAccountLinkControllerApproveManagedCardResponses.gen';
import type { EshopCustomerAccountLinkControllerCancelManagingAccountCardData } from './EshopCustomerAccountLinkControllerCancelManagingAccountCardData.gen';
import type { EshopCustomerAccountLinkControllerCancelManagingAccountCardErrors } from './EshopCustomerAccountLinkControllerCancelManagingAccountCardErrors.gen';
import type { EshopCustomerAccountLinkControllerCancelManagingAccountCardResponses } from './EshopCustomerAccountLinkControllerCancelManagingAccountCardResponses.gen';
import type { EshopCustomerAccountLinkControllerConnectAnonymousCardData } from './EshopCustomerAccountLinkControllerConnectAnonymousCardData.gen';
import type { EshopCustomerAccountLinkControllerConnectAnonymousCardErrors } from './EshopCustomerAccountLinkControllerConnectAnonymousCardErrors.gen';
import type { EshopCustomerAccountLinkControllerConnectAnonymousCardResponses } from './EshopCustomerAccountLinkControllerConnectAnonymousCardResponses.gen';
import type { EshopCustomerAccountLinkControllerGetAllData } from './EshopCustomerAccountLinkControllerGetAllData.gen';
import type { EshopCustomerAccountLinkControllerGetAllErrors } from './EshopCustomerAccountLinkControllerGetAllErrors.gen';
import type { EshopCustomerAccountLinkControllerGetAllResponses } from './EshopCustomerAccountLinkControllerGetAllResponses.gen';
import type { EshopCustomerAccountLinkControllerGetAssignedChildParentData } from './EshopCustomerAccountLinkControllerGetAssignedChildParentData.gen';
import type { EshopCustomerAccountLinkControllerGetAssignedChildParentErrors } from './EshopCustomerAccountLinkControllerGetAssignedChildParentErrors.gen';
import type { EshopCustomerAccountLinkControllerGetAssignedChildParentResponses } from './EshopCustomerAccountLinkControllerGetAssignedChildParentResponses.gen';
import type { EshopCustomerAccountLinkControllerManagingCardRequestData } from './EshopCustomerAccountLinkControllerManagingCardRequestData.gen';
import type { EshopCustomerAccountLinkControllerManagingCardRequestErrors } from './EshopCustomerAccountLinkControllerManagingCardRequestErrors.gen';
import type { EshopCustomerAccountLinkControllerManagingCardRequestResponses } from './EshopCustomerAccountLinkControllerManagingCardRequestResponses.gen';
import type { EshopCustomerAccountLinkControllerRejectCardManageRequestData } from './EshopCustomerAccountLinkControllerRejectCardManageRequestData.gen';
import type { EshopCustomerAccountLinkControllerRejectCardManageRequestErrors } from './EshopCustomerAccountLinkControllerRejectCardManageRequestErrors.gen';
import type { EshopCustomerAccountLinkControllerRejectCardManageRequestResponses } from './EshopCustomerAccountLinkControllerRejectCardManageRequestResponses.gen';
import type { EshopCustomerAccountLinkControllerRemoveManagedCustomerLinkData } from './EshopCustomerAccountLinkControllerRemoveManagedCustomerLinkData.gen';
import type { EshopCustomerAccountLinkControllerRemoveManagedCustomerLinkErrors } from './EshopCustomerAccountLinkControllerRemoveManagedCustomerLinkErrors.gen';
import type { EshopCustomerAccountLinkControllerRemoveManagedCustomerLinkResponses } from './EshopCustomerAccountLinkControllerRemoveManagedCustomerLinkResponses.gen';
import type { EshopCustomerAccountLinkControllerSetAssignedTypeData } from './EshopCustomerAccountLinkControllerSetAssignedTypeData.gen';
import type { EshopCustomerAccountLinkControllerSetAssignedTypeErrors } from './EshopCustomerAccountLinkControllerSetAssignedTypeErrors.gen';
import type { EshopCustomerAccountLinkControllerSetAssignedTypeResponses } from './EshopCustomerAccountLinkControllerSetAssignedTypeResponses.gen';
import type { EshopCustomerAccountLinkControllerSetRegisteredTypeData } from './EshopCustomerAccountLinkControllerSetRegisteredTypeData.gen';
import type { EshopCustomerAccountLinkControllerSetRegisteredTypeErrors } from './EshopCustomerAccountLinkControllerSetRegisteredTypeErrors.gen';
import type { EshopCustomerAccountLinkControllerSetRegisteredTypeResponses } from './EshopCustomerAccountLinkControllerSetRegisteredTypeResponses.gen';
import type { Options } from './Options.gen';

export class EshopCustomerAccountLinkController {
    /**
     * Manage account link request.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CUSTOMER_CARD** - Customer card does not exist or has invalid card state.<br>
     * + **INVALID_ACCOUNT** - Account does not exist or another customer is assigned to this account.<br>
     * + **CANNOT_MANAGE_OWN_CARD** - Can´t manage own card.<br>
     * + **CUSTOMER_CARD_ALREADY_MANAGED_BY_CURRENT_ACCOUNT** - Customer card already managed by current account.
     */
    public static managingCardRequest<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountLinkControllerManagingCardRequestData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerAccountLinkControllerManagingCardRequestResponses, EshopCustomerAccountLinkControllerManagingCardRequestErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links-managed-account-link-request',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get customer account links that are linked to the logged-in account.
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerAccountLinkControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerAccountLinkControllerGetAllResponses, EshopCustomerAccountLinkControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links',
            ...options
        });
    }
    
    /**
     * Get legal representative of an assigned child already linked to the logged-in account.
     */
    public static getAssignedChildParent<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerAccountLinkControllerGetAssignedChildParentData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerAccountLinkControllerGetAssignedChildParentResponses, EshopCustomerAccountLinkControllerGetAssignedChildParentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links/assigned-child-parent',
            ...options
        });
    }
    
    /**
     * Confirm a customer account.
     *
     * Confirm a request for managing a customer's card by another customer based on token.<br>
     * Body contains a token.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **APPROVE_MANAGED_CARD_INVALID_TOKEN** - Token is invalid or belongs to a different account.<br>
     * + **APPROVE_MANAGED_CARD_EXPIRED_TOKEN** - Token has already expired.<br>
     * + **APPROVE_MANAGED_CARD_MAX_ACCOUNTS_REACHED** - Card cannot be managed by more than two accounts.
     */
    public static approveManagedCard<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountLinkControllerApproveManagedCardData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerAccountLinkControllerApproveManagedCardResponses, EshopCustomerAccountLinkControllerApproveManagedCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links/manage-approve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reject card manage request.
     *
     * Reject card manage request based on token.<br>
     * Body contains a token.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **REJECT_MANAGED_CARD_INVALID_TOKEN** - Token is invalid or belongs to a different account.
     */
    public static rejectCardManageRequest<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountLinkControllerRejectCardManageRequestData, ThrowOnError>) {
        return (options.client ?? client).delete<EshopCustomerAccountLinkControllerRejectCardManageRequestResponses, EshopCustomerAccountLinkControllerRejectCardManageRequestErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links/{token}/reject-card-manage-request',
            ...options
        });
    }
    
    /**
     * Remove customer-account link with the type MANAGED.
     */
    public static removeManagedCustomerLink<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountLinkControllerRemoveManagedCustomerLinkData, ThrowOnError>) {
        return (options.client ?? client).delete<EshopCustomerAccountLinkControllerRemoveManagedCustomerLinkResponses, EshopCustomerAccountLinkControllerRemoveManagedCustomerLinkErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links/managed-customer/{customerId}',
            ...options
        });
    }
    
    /**
     * Remove account-customer link with the type MANAGED by managing account id.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **INVALID_ACCOUNT_CUSTOMER** - Link between account and customer does not exists.
     */
    public static cancelManagingAccountCard<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountLinkControllerCancelManagingAccountCardData, ThrowOnError>) {
        return (options.client ?? client).delete<EshopCustomerAccountLinkControllerCancelManagingAccountCardResponses, EshopCustomerAccountLinkControllerCancelManagingAccountCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links/managing-account/{id}',
            ...options
        });
    }
    
    /**
     * Set account-customer link with the type MANAGED to type REGISTERED.
     */
    public static setRegisteredType<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountLinkControllerSetRegisteredTypeData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerAccountLinkControllerSetRegisteredTypeResponses, EshopCustomerAccountLinkControllerSetRegisteredTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links/{id}/registered',
            ...options
        });
    }
    
    /**
     * Set account-customer link with the type MANAGED to type ASSIGNED.
     */
    public static setAssignedType<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountLinkControllerSetAssignedTypeData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerAccountLinkControllerSetAssignedTypeResponses, EshopCustomerAccountLinkControllerSetAssignedTypeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links/{id}/assigned',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Connect anonymous card (portable) to the managing account.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **CONNECT_ANONYMOUS_CARD_NOT_ALLOWED** - Connecting anonymous card is not allowed for this configuration.<br>
     * + **ANONYMOUS_CARD_ALREADY_CONNECTED_TO_ACCOUNT** - Anonymous card is already directly connected to this account.<br>
     * + **INVALID_CUSTOMER_CARD** - Customer card does not exist or has invalid card state.<br>
     * + **INVALID_CUSTOMER_CARD_TYPE** - Customer card can not be this type.<br>
     * + **BANK_CARD_CANNOT_BE_ATTACHED_TO_ACCOUNT_WITH_SMART_CARD** - Bank card cannot be attached to an account with a smart card.<br>
     * + **INVALID_ACCOUNT_CUSTOMER** - Link between account and customer does not exists.
     */
    public static connectAnonymousCard<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountLinkControllerConnectAnonymousCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerAccountLinkControllerConnectAnonymousCardResponses, EshopCustomerAccountLinkControllerConnectAnonymousCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-account-links/{id}/anonymous',
            ...options
        });
    }
}
